import React from 'react';
import { motion } from 'framer-motion';
import { SectionHeading } from './SectionHeading';
const OUTCOMES = ['Identificar las tres caras más comunes de tu autoexigencia: la productiva, la relacional y la perfeccionista.', 'Descansar sin que aparezca esa culpa que te empuja a seguir haciendo algo “productivo”.', 'Reconocer las señales de tu cuerpo antes de llegar al agotamiento.', 'Entender el origen de esa voz exigente que te acompaña hace años, y por qué dejó de ser necesaria.', 'Poner un límite con frases simples, sin justificarte con una lista de excusas.', 'Cuatro herramientas concretas para bajar el ritmo, de a una y sin desmoronarte.', 'Una pausa consciente de 5 minutos para usar en cualquier momento del día.', 'Diferenciar la urgencia real de la ansiedad disfrazada de urgencia.', 'Una brújula de tres preguntas para decidir desde lo que te importa, no desde el miedo.', 'Un diario guiado de 7 días para mapear cuándo tu autoexigencia se activa más.'];
export function Outcomes() {
  return <section className="w-full bg-sage-band py-20 md:py-28" data-id="element-94" data-mp="32wzw8xd9mgm3">
      <div className="mx-auto max-w-4xl px-6" data-id="element-95" data-mp="2xxwqtbtdi8dl">
        <SectionHeading eyebrow="Lo que vas a lograr" title={<>
              Al terminar de leerlo,{' '}
              <em className="italic text-sage" data-id="element-97" data-mp="2p6cuewc7kals">vas a poder…</em>
            </>} data-id="element-96" data-mp="2xz6qu6jsdqmv" />
        <div className="mt-14 grid grid-cols-1 gap-x-12 gap-y-8 md:grid-cols-2" data-id="element-98" data-mp="2k6qlv07brijb">
          {OUTCOMES.map((text, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-40px'
        }} transition={{
          duration: 0.5,
          ease: 'easeOut',
          delay: i % 2 * 0.06
        }} className="flex items-start gap-5" data-id="element-99" data-mp="2f7nm9va464iq" data-mpi={i}>
              <span className="font-serif text-3xl leading-none text-sage" data-id="element-100" data-mp="1xwrvtp2l9cj0">
                {String(i + 1).padStart(2, '0')}
              </span>
              <p className="font-sans text-[15px] leading-relaxed text-ink-soft" data-id="element-101" data-mp="1oyprazjnc1qz">
                {text}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}